<template>
  <hotel-form />
</template>

<script>
import HotelForm from '@/components/forms/HotelForm'
export default {
  components: {
    HotelForm
  }
}
</script>
